import { OnInit } from '@angular/core';
import { Subject } from "rxjs";
import { BsModalRef } from "ngx-bootstrap";
import { TriggerDatasetService } from "@app/workflow-common/services/trigger-dataset.service";
import { FormBuilder, FormControl, Validators } from "@angular/forms";
import { InitialBlock } from "@app/workflow-common/services/DagSourceModel";
import { TranslateService } from "@ngx-translate/core";
var TriggerConditionPanelComponent = /** @class */ (function () {
    function TriggerConditionPanelComponent(modalRef, triggerService, _formBuilder, _translateService) {
        this.modalRef = modalRef;
        this.triggerService = triggerService;
        this._formBuilder = _formBuilder;
        this._translateService = _translateService;
        this.rules = [];
        this.isEdit = false;
        this.select2OptionsFields = {};
        this.select2ConfigOperator = {
            minimumResultsForSearch: -1
        };
        this.isGroupTypeField = false;
        this.groupFields = [];
        this.operators = {};
        this.select2DataFunction = function (item) { return item.text; };
        this.select2FieldInstance = {};
        this.select2OperatorInstance = {};
        this.isFormSubmitted = false;
        this.blockId = 'cs_initializer';
        this.selectedField = [];
    }
    TriggerConditionPanelComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.onClose = new Subject();
        this.operators = this.triggerService.getOperators();
        this.prepareFieldsAsObject();
        this.form = this._formBuilder.group({
            mainObjectName: new FormControl(this.objectName, [Validators.required]),
            conditions: new FormControl('and'),
            rules: this._formBuilder.array([]),
        });
        if (this.rules.length == 0) {
            this.addRule();
        }
        else {
            this.rules.forEach(function (rule) {
                _this.addRule(rule);
                _this.selectedField.push(rule.col_name);
            });
        }
        this.form.valueChanges.subscribe(function (value) {
            _this.selectedField = [];
            value.rules.forEach(function (rule) {
                _this.selectedField.push(rule.col_name);
            });
            console.log(_this.selectedField);
        });
        this.deleteConfirmModalConfig = {
            showModal: false,
            modalType: 'confirm',
            title: 'Dummy',
            actionText: 'DELETE',
            itemText: 'DELETE',
            confirmBtnText: 'DELETE',
            confirmBtnType: 'DELETE',
            closeText: 'cancel',
            confirmBxValidationMsg: this._translateService.instant('confirmation.warning.text', { word: 'DELETE', message: 'remove the automation' }),
            message: { warningTxt: 'Delete.Automation.Warning.Message', helpTxtList: ['Delete.Automation.Confirmation.Message'] },
            defaultTextMessage: false,
            doAction: this.removeRuleCondition.bind(this)
        };
    };
    TriggerConditionPanelComponent.prototype.prepareFieldsAsObject = function () {
        this.isGroupTypeField = this.dagSourceModel.isGroupField();
        this.groupFields = this.dagSourceModel.getGroupFields();
        // this.fieldsAsObject = this.dagSourceModel.getFieldMetadata();
        // if(this.form.get('mainObjectName').value != '') {
        // const fields = [...this.fields];
        this.fieldsAsObject = Object.values(this.dagSourceModel.getFieldMetadata()).reduce(function (acc, current) {
            var keyName = current['col_name'];
            if (!current['fieldType']) {
                current['fieldType'] = 'static';
            }
            if (!current['pageType']) {
                current['pageType'] = '';
            }
            acc[keyName] = current;
            return acc;
        }, {});
        // console.log('this.dagSourceModel.getFieldMetadata()', this.dagSourceModel.getFieldMetadata(), this.fieldsAsObject)
    };
    Object.defineProperty(TriggerConditionPanelComponent.prototype, "formRules", {
        get: function () {
            return this.form.controls.rules;
        },
        enumerable: true,
        configurable: true
    });
    TriggerConditionPanelComponent.prototype.onChangeField = function (value, index) {
        var keyName = 'field_' + index;
        var formRules = this.formRules;
        formRules.controls[index].get('type').setValue(this.fieldsAsObject[value]['type']);
        formRules.controls[index].get('input').setValue(this.fieldsAsObject[value]['input']);
        formRules.controls[index].get('text').setValue(this.fieldsAsObject[value]['text']);
        formRules.controls[index].get('fieldType').setValue(this.fieldsAsObject[value]['fieldType']);
        formRules.controls[index].get('pageType').setValue(this.fieldsAsObject[value]['pageType']);
        formRules.controls[index].get('operator').setValue(this.fieldsAsObject[value]['operators'][0]);
        if (this.select2OperatorInstance.hasOwnProperty(keyName)) {
            this.select2OperatorInstance[keyName].select2('val', this.fieldsAsObject[value]['operators'][0]);
        }
        formRules.controls[index].get('value').setValue('');
        if (this.select2FieldInstance.hasOwnProperty(keyName)) {
            this.select2FieldInstance[keyName].select2('val', '');
        }
    };
    TriggerConditionPanelComponent.prototype.addRule = function (ruleItem) {
        if (ruleItem === void 0) { ruleItem = null; }
        var formRules = this.form.controls.rules;
        var rule = {
            col_name: '',
            input: '',
            operator: 'equal',
            text: '',
            type: '',
            value: '',
            fieldType: 'static',
            pageType: '',
            templateId: '',
        };
        if (ruleItem) {
            rule['col_name'] = ruleItem['col_name'];
            rule['input'] = ruleItem['input'];
            rule['operator'] = ruleItem['operator'];
            rule['text'] = ruleItem['text'];
            rule['type'] = ruleItem['type'];
            rule['value'] = ruleItem['value'];
            rule['fieldType'] = !ruleItem['fieldType'] ? 'static' : ruleItem['fieldType'];
            rule['pageType'] = !ruleItem['pageType'] ? '' : ruleItem['pageType'];
            rule['templateId'] = !ruleItem['templateId'] ? '' : ruleItem['templateId'];
        }
        formRules.push(this._formBuilder.group({
            col_name: new FormControl(rule['col_name'], [Validators.required]),
            operator: new FormControl(rule.operator, [Validators.required]),
            value: new FormControl(rule.value, [Validators.required]),
            type: new FormControl(rule.type),
            input: new FormControl(rule.input),
            text: new FormControl(rule.text),
            fieldType: new FormControl(rule.fieldType),
            pageType: new FormControl(rule.pageType),
            templateId: new FormControl(rule.templateId)
        }));
    };
    TriggerConditionPanelComponent.prototype.removeRuleCondition = function (index, cb) {
        var control = this.form.controls['rules'];
        control.removeAt(index);
        cb('SUCCESS');
    };
    TriggerConditionPanelComponent.prototype.setSelect2OperatorInstance = function (instance, index) {
        var keyName = 'field_' + index;
        this.select2OperatorInstance[keyName] = instance;
    };
    TriggerConditionPanelComponent.prototype.setSelect2InstanceFieldValue = function (instance, index, isMultiple) {
        if (isMultiple === void 0) { isMultiple = false; }
        var keyName = isMultiple ? 'field_multiple_' + index : 'field_' + index;
        this.select2FieldInstance[keyName] = instance;
    };
    TriggerConditionPanelComponent.prototype.onSelectMultipleSelect = function (value, index) {
        var formRules = this.formRules;
        formRules.controls[index].get('value').setValue(value);
    };
    TriggerConditionPanelComponent.prototype.onChangeOperator = function (value, index) {
        var keyName;
        var formRules = this.formRules;
        formRules.controls[index].get('value').setValue('');
        if (value == 'in' || value == 'not_in')
            keyName = 'field_' + index;
        else
            keyName = 'field_multiple_' + index;
        if (this.select2FieldInstance.hasOwnProperty(keyName))
            this.select2FieldInstance[keyName].select2('destroy');
    };
    TriggerConditionPanelComponent.prototype.onBeforeRemove = function (index) {
        var nthCondition = (index + 1);
        this.deleteConfirmModalConfig.title = this._translateService.instant('Delete.Trigger.Condition', { nth: nthCondition });
        this.deleteConfirmModalConfig.confirmBxValidationMsg = this._translateService.instant('confirmation.warning.text', { word: 'DELETE', message: 'remove the condition ' + nthCondition });
        this.deleteConfirmModalConfig.actionArg = index;
        this.deleteConfirmModalConfig.showModal = true;
    };
    TriggerConditionPanelComponent.prototype.onCloseConfirmation = function () {
        this.deleteConfirmModalConfig.showModal = false;
    };
    // removeUsedRuleCondition(){
    //     this.currentFields = this.fields;
    //     this.form.value.rules.forEach( rule => this.removeColumnFromFields(rule.col_name));
    // }
    // removeColumnFromFields(col_name: any){
    //     let Index: any;
    //     Object.entries(this.currentFields).forEach( ([key,objectFields ]) => {
    //         Index = objectFields.findIndex(field=>
    //                 field.col_name == col_name
    //             );
    //         if(Index >= 0){
    //             // this.currentFields[key].splice(Index,1);
    //         }
    //     });
    // }
    TriggerConditionPanelComponent.prototype.save = function () {
        this.isFormSubmitted = true;
        var _a = this.form.value, mainObjectName = _a.mainObjectName, rules = _a.rules, conditions = _a.conditions;
        var initBlockData = new InitialBlock(this.blockId, 0, 'initializer', conditions, rules, mainObjectName);
        this.onClose.next({
            action: this.isEdit ? 'edit' : 'add',
            isEdit: this.isEdit,
            node: initBlockData
        });
    };
    TriggerConditionPanelComponent.prototype.onCloseModal = function () {
        this.onClose.next({
            action: 'close'
        });
        this.modalRef.hide();
    };
    return TriggerConditionPanelComponent;
}());
export { TriggerConditionPanelComponent };
